// extracted by mini-css-extract-plugin
export default {"rubber-product-catalog__title":"rubber-catalog_rubber-product-catalog__title__NT33j"};